
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/premier-pet-care-plan",
      function () {
        return require("private-next-pages/services/premier-pet-care-plan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/premier-pet-care-plan"])
      });
    }
  